<template>
	<span>
		<label class="control-label cursor-pointer" @click="showColumnSettings">
			<i class="fa fa-columns m-r-5"></i>
			Column Settings
		</label>
		<!-- COLUMN SETTINGS MODAL -->
		<div ref="columSettingsModal" class="modal fade" role="dialog" tabindex="-1">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
						<h4 class="modal-title" id="exampleModalLabeexl">Column Settings</h4>
					</div>

					<div class="modal-body container-fluid">
						<div class="modal-subheader">
							<i class="fa fa-info-circle modal-subheader-icon"></i>
							<div>
								<div>
									<span class="text-bold m-r-5">Line 1:</span>
									Always visible; can be used to sort or filter results
								</div>
								<div class="p-t-5">
									<span class="text-bold m-r-5"> Line 2:</span>
									Visible when a row is expanded; can not be used to sort or filter results
								</div>
								<div class="p-t-5">
									<span class="text-bold m-r-5">Hidden:</span>
									Never visible
								</div>
							</div>
						</div>

						<div class="p-25">
							<div class="row text-bold m-b-10">
								<div class="col-xs-6">
									Column Name
								</div>
								<div class="col-xs-2 text-center">
									Line1
								</div>
								<div class="col-xs-2 text-center">
									Line2
								</div>
								<div class="col-xs-2 text-center">
									Hidden
								</div>
							</div>

							<draggable :list="column_settings" class="master-drag-area">
								<div class="row p-t-5" v-for="item in column_settings" v-if="item.column !== 'balance' || show_balance_column">
									<div class="col-xs-6">
										<i class="fa fa-ellipsis-v"></i>
										{{ item.label }}
									</div>
									<div class="col-xs-2 text-center">
										<i class="fa fa-check-square-o" v-if="item.line === 1"></i>
										<i class="fa fa-square-o" v-else @click="changeLine(item.column,1)"></i>
									</div>
									<div class="col-xs-2 text-center">
										<i class="fa fa-check-square-o" v-if="item.line === 2"></i>
										<i class="fa fa-square-o" v-else @click="changeLine(item.column,2)"></i>
									</div>
									<div class="col-xs-2 text-center">
										<i class="fa fa-check-square-o" v-if="item.line === 3"></i>
										<i class="fa fa-square-o" v-else @click="changeLine(item.column,3)"></i>
									</div>
								</div>
							</draggable>

						</div>
					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><i class="fa fa-times"></i> Close</button>
						<button type="button" class="btn btn-lg btn-primary" @click="saveSettings"><span class="fa fa-check"></span> Save</button>
					</div>
				</div>
			</div>
		</div>
	</span>
</template>

<script>
	import draggable from 'vuedraggable';

	export default {
		name: "document-column-settings-modal",
		components: {
			draggable
		},
		props: {
			headers : Array,
			show_balance_column : Boolean
		},
		data: function () {
			return {
				column_settings : []
			};
		},
		methods: {
			showColumnSettings () {
				// Clone the prop values into a local data field
				this.column_settings = JSON.parse(JSON.stringify(this.headers));
				$(this.$refs.columSettingsModal).modal('show');
			},

			changeLine (column, line) {
				const col = this.column_settings.find(col => col.column === column);
				if (col) {
					col.line = line;
				}
			},

			saveSettings () {
				this.$emit('save-settings', this.column_settings);
				$(this.$refs.columSettingsModal).modal('hide');
			},
		}
	}
</script>

<style scoped lang="scss">
@import 'resources/assets/sass/global_variables';

.modal {
	.modal-subheader {
		position: relative;

		> i {
			position: absolute;
		}

		> div {
			padding-left: 35px;
		}
	}

	.master-drag-area {
		.row {
			cursor: move;

			i.fa:not(.fa-ellipsis-v) {
				cursor: default;
			}
		}
	}

	i.fa {
		vertical-align: middle;
	}

	i.fa-ellipsis-v {
		color: lighten($body-text, 35%);
		margin-right: 5px;
	}

	i.fa-square-o {
		zoom: 1.5;
		margin-right: 1.2px;
	}

	i.fa-check-square-o {
		zoom: 1.5;
	}
}
</style>



// WEBPACK FOOTER //
// document-column-settings-modal.vue?23828aca